// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   Input,
//   Button,
//   Modal,
//   Space,
//   message,
//   Tag,
//   Typography,
//   Select,
//   Row,
//   Col,
//   DatePicker,
//   InputNumber,
//   Tabs,
//   Divider,
//   Steps,
//   Radio,
//   Spin,
// } from "antd";
// import {
//   PlusOutlined,
//   ReloadOutlined,
//   SearchOutlined,
//   EyeOutlined,
//   CheckOutlined,
//   FilePdfOutlined,
//   MinusOutlined,
// } from "@ant-design/icons";
// import {
//   downloadCommande,
//   get_commande,
//   getall_commandes,
//   update_commande,
//   toggle_commande,
//   export_commandes,
//   create_commande,
//   create_additionnal_commande,
// } from "../../api/commandes";
// import { getPermissionsFromToken, hasPermission } from "../../utils/utils";

// import { get_ListeRegion } from "../../api/region";
// import { get_all_agences, get_all_users } from "../../api/users";
// import Notification from "../../composants/Notification";
// import "moment/locale/fr";
// import moment from "moment";
// import { get_ListeClients } from "../../api/clients";
// import { get_ListeChauffeur } from "../../api/chauffeur";
// import { getall_facture } from "../../api/factures";
// import { get_listeCamion } from "../../api/camion";
// import { select } from "framer-motion/client";
// const { RangePicker } = DatePicker;
// const { Text } = Typography;
// const { Option } = Select;
// const { TabPane } = Tabs;
// const commonInputStyle = {
//   width: "100%",
//   height: 40,
//   display: "flex",
//   alignItems: "center",
// };

// const { TextArea } = Input;

// const Commandes = () => {
//   const [searchText, setSearchText] = useState("");
//   const [dateRange, setDateRange] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [selectedCommandes, setselectedCommandes] = useState({});
//   const [listeCommandes, setlisteCommandes] = useState([]);
//   const [filteredCommandes, setfilteredCommandes] = useState([]);
//   const [showToast, setshowToast] = useState(false);
//   const [modalVisible, setModalVisible] = useState(false);
//   const [listeChauffeur, setlisteChauffeur] = useState([]);
//   const [notif, setnotif] = useState({
//     message: null,
//     info: null,
//   });
//   const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
//   const [tableFilters, setTableFilters] = useState({});
//   const [selectedRowKeys, setSelectedRowKeys] = useState([]); // pour stocker les IDs
//   const rowSelection = {
//     selectedRowKeys,
//     onChange: (keys, rows) => {
//       setSelectedRowKeys(keys);
//       setSelectedRows(rows);
//     },
//     selections: [
//       Table.SELECTION_ALL,
//       Table.SELECTION_INVERT,
//       Table.SELECTION_NONE,
//     ],
//   };
//   const InfoItem = ({ label, value }) => (
//     <div>
//       <strong>{label} :</strong>{" "}
//       <span style={{ opacity: 0.85 }}>{value || "-"}</span>
//     </div>
//   );
//   const [showmodaldetail, setshowmodaldetail] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [validationModalVisible, setValidationModalVisible] = useState(false);

//   const [showModalAdd, setshowModalAdd] = useState(false);
//   const [currentStep, setCurrentStep] = useState(1);
//   const [listAgence, setListeAgence] = useState([]);
//   const [listeUsers, setlisteUsers] = useState([]);
//   const [listeFactures, setlisteFactures] = useState([]);
//   const [selectedFactures, setselectedFactures] = useState({});
//   const [selectedCamion, setSelectedCamion] = useState([
//     {
//       camion_id: null,
//       chauffeur_id: null,
//       coefficient_charge: "",
//       coefficient_vide: "",
//       compagnie: "COMPAGNIE MASOANDRO",
//       agence: "Antananarivo",
//       observation: "",
//     },
//   ]);
//   const [listeCamions, setlisteCamions] = useState([]);
//   const STATUTS_VERROUILLES = ["valide_direction", "valide_client"];
//   const isCommandeLocked = STATUTS_VERROUILLES.includes(
//     selectedCommandes.statut_commande,
//   );

//   useEffect(() => {
//     fetchListeAgence();
//     fetchUsers();
//     fetchCommandes();
//     fetchChauffeur();
//     fetchFacture();
//     fetchListeCamion();
//   }, [selectedCommandes]);

//   const fetchListeCamion = async () => {
//     const res = await get_listeCamion();
//     if (res.status === "success") {
//       setlisteCamions(res.data);
//     }
//   };

//   const fetchUsers = async () => {
//     const res = await get_all_users();
//     setlisteUsers(res.data);
//   };

//   const fetchFacture = async (range = []) => {
//     try {
//       setLoading(true);
//       let start, end;
//       if (range.length === 2) {
//         start = moment(range[0]).format("YYYY-MM-DD HH:mm:ss");
//         end = moment(range[1]).format("YYYY-MM-DD HH:mm:ss");
//       } else {
//         end = moment().format("YYYY-MM-DD HH:mm:ss");
//         start = moment().subtract(6, "months").format("YYYY-MM-DD HH:mm:ss");
//       }
//       const res = await getall_facture({ start, end });
//       console.log("---------------------");

//       console.log(res.data);
//       if (res.data && Array.isArray(res.data)) {
//         console.log(res);
//         setlisteFactures(res.data);
//       } else {
//         console.log("///////////////////////");
//         message.warning("Aucune donnée trouvée.");
//       }
//     } catch (error) {
//       message.error("Erreur lors du chargement des factures");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchListeAgence = async () => {
//     const res = await get_all_agences();
//     if (res.status === "success") {
//       setListeAgence(res.data);
//     }
//   };

//   const [loading, setLoading] = useState(false);

//   const charges =
//     selectedCommandes.additional?.length > 0
//       ? []
//       : [
//         {
//           name: "Carburant Trajet Aller",
//           qtyField: "carburant_aller",
//           priceField: "prix_go",
//         },
//         {
//           name: "Carburant Trajet Retour",
//           qtyField: "carburant_retour",
//           priceField: "prix_go",
//         },
//         {
//           name: "Perdiem Chauffeur",
//           qtyField: "perdiem_chauffeur_multi",
//           priceField: "perdiem_chauffeur",
//         },
//         {
//           name: "Perdiem Aide-Chauffeur",
//           qtyField: "perdiem_aide_multi",
//           priceField: "perdiem_aide",
//         },
//         {
//           name: "Crédit de communication",
//           qtyField: "credit_multi",
//           priceField: "credit",
//         },
//         {
//           name: "Parking",
//           qtyField: "parking_multi",
//           priceField: "parking",
//         },
//         {
//           name: "Fiche de Contravention",
//           qtyField: "contravention_multi",
//           priceField: "contravention",
//         },
//         {
//           name: "Droit de Chargement",
//           qtyField: "chargement_multi",
//           priceField: "chargement",
//         },

//         {
//           name: "Déchargement",
//           qtyField: "dechargement_multi",
//           priceField: "dechargement",
//         },
//         {
//           name: "Arrimage",
//           qtyField: "arrimage_multi",
//           priceField: "arrimage",
//         },
//         {
//           name: "Divers",
//           qtyField: "divers_multi",
//           priceField: "divers",
//         },
//       ];

//   const dataSource =
//     selectedCommandes?.additional?.length > 0
//       ? // ── Mode additional : on mappe sur les lignes additional ──
//       selectedCommandes.additional.map((item, index) => {
//         const qty = Number(item.qte) || 1;
//         const unitPrice = Number(item.prix_unitaire) || 0;
//         return {
//           key: index,
//           name: item.nom,
//           qty,
//           unitPrice,
//           total: qty * unitPrice,
//           qtyField: "qte",
//           priceField: "prix_unitaire",
//           id: item.id, // utile pour updateAdditionalRow
//         };
//       })
//       : // ── Mode standard : on mappe sur la définition CHARGES_DEF ──
//       charges.map((item, index) => {
//         const qty = item.qtyField
//           ? Number(selectedCommandes[item.qtyField])
//           : 1;
//         const unitPrice = Number(selectedCommandes[item.priceField]) || 0;
//         return {
//           key: index,
//           name: item.name,
//           qty,
//           unitPrice,
//           total: qty * unitPrice,
//           qtyField: item.qtyField,
//           priceField: item.priceField,
//         };
//       });

//   const totalGeneral = dataSource.reduce((sum, item) => sum + item.total, 0);

//   const columns = [
//     { title: "DESIGNATION", dataIndex: "name", key: "name" },

//     {
//       title: "QUANTITE",
//       dataIndex: "qty",
//       key: "qty",
//       align: "right",
//       render: (value, record) => (
//         <Input
//           style={{ width: 80, textAlign: "right" }}
//           value={value}
//           onChange={(e) => {
//             if (selectedCommandes.additional?.length > 0) {
//               updateAdditionalField(record.id, "qte", e.target.value);
//             } else {
//               updateField(record.qtyField, Number(e.target.value));
//             }
//           }}
//         />
//       ),
//     },

//     {
//       title: "PRIX UNITAIRE",
//       dataIndex: "unitPrice",
//       key: "unitPrice",
//       align: "right",
//       render: (value, record) => (
//         <Input
//           style={{ width: 120, textAlign: "right" }}
//           value={value}
//           onChange={(e) => {
//             if (selectedCommandes.additional?.length > 0) {
//               updateAdditionalField(record.id, "prix_unitaire", e.target.value);
//             } else {
//               updateField(record.priceField, Number(e.target.value));
//             }
//           }}
//         />
//       ),
//     },

//     {
//       title: "MONTANT",
//       dataIndex: "total",
//       key: "total",
//       align: "right",
//       render: (val) => val.toLocaleString(),
//     },
//   ];

//   const fetchCommandes = async (range = []) => {
//     try {
//       setLoading(true);
//       let start, end;
//       if (range.length === 2) {
//         start = moment(range[0]).format("YYYY-MM-DD HH:MM:SS");
//         end = moment(range[1]).format("YYYY-MM-DD");
//       } else {
//         end = moment().format("YYYY-MM-DD");
//         start = moment().subtract(3, "months").format("YYYY-MM-DD HH:MM:SS");
//       }
//       const res = await getall_commandes({ start, end });
//       console.log(res);
//       if (res.data && Array.isArray(res.data)) {
//         setlisteCommandes(res.data);
//         setfilteredCommandes(res.data);
//       } else {
//         message.warning("Aucune donnée trouvée.");
//       }
//     } catch (error) {
//       message.error("Erreur lors du chargement des devis");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSearch = (e) => {
//     const value = e.target.value.toLowerCase();
//     setSearchText(value);
//     const filtered = listeCommandes.filter((item) => {
//       const ref = item.ref?.toLowerCase?.() || "";
//       const desc = item.description?.toLowerCase?.() || "";
//       const client = item.client_nom?.toLowerCase?.() || "";
//       return (
//         ref.includes(value) || desc.includes(value) || client.includes(value)
//       );
//     });
//     setfilteredCommandes(filtered);
//   };

//   const fetchChauffeur = async () => {
//     const res = await get_ListeChauffeur();
//     setlisteChauffeur(res.data || []);
//   };

//   const handleDateChange = (dates) => {
//     setDateRange(dates);
//   };

//   const handlegetcommandeyid = async (record) => {
//     const res = await get_commande(record.commande_id);
//     console.log(res.data);
//     setselectedCommandes(res.data);
//     setshowmodaldetail(true);
//   };

//   const openValidationModal = (record) => {
//     console.log(record);
//     setselectedCommandes(record);
//     setValidationModalVisible(true);
//   };

//   const closeValidationModal = () => {
//     setselectedCommandes({});
//     setValidationModalVisible(false);
//   };

//   const columns_commandes = [
//     {
//       title: "Id",
//       dataIndex: "commande_id",
//       key: "commande_id",
//       // width: "50%",
//     },
//     {
//       title: "Date",
//       dataIndex: "create_at",
//       key: "create_at",
//       align: "center",
//       render: (text) =>
//         new Date(text).toISOString().slice(0, 19).replace("T", " "),
//     },
//     {
//       title: "Type",
//       dataIndex: "entretien_id",
//       key: "type",
//       width: 120,
//       align: "center",
//       filters: [
//         { text: "Opération", value: 0 },
//         { text: "Entretien", value: 1 },
//       ],
//       onFilter: (value, record) =>
//         value === 0
//           ? record.entretien_id === 0 || record.entretien_id === null
//           : record.entretien_id !== 0 && record.entretien_id !== null,
//       render: (entretien_id) => (
//         <Tag
//           color={entretien_id === 0 || entretien_id === null ? "cyan" : "green"}
//         >
//           {entretien_id === 0 || entretien_id === null
//             ? "Opération"
//             : "Entretien"}
//         </Tag>
//       ),
//     },
//     {
//       title: "Utilisateur",
//       dataIndex: "user_id",
//       key: "user_id",
//       align: "center",

//       // 🔹 Filtre par agence
//       filters: listAgence.map((a) => ({
//         text: a.nom,
//         value: `agence_${a.id}`, // on marque que c’est un filtre agence
//       })),

//       // 🔹 OnFilter pour gérer filtre combiné
//       onFilter: (value, record) => {
//         const user = listeUsers.find((u) => u.id === record.user_id);
//         if (!user) return false;

//         // Filtre par agence
//         if (value.startsWith("agence_")) {
//           const agenceId = Number(value.split("_")[1]);
//           return user.agence_id === agenceId;
//         }

//         // Filtre par utilisateur
//         return user.id === value;
//       },

//       // 🔹 Affichage + filtres utilisateurs (dynamique selon l’agence sélectionnée)
//       render: (_, record) => {
//         const user = listeUsers.find((u) => u.id === record.user_id);
//         if (!user) return "—";

//         const agence = listAgence.find((a) => a.id === user.agence_id);
//         const fullName = `${user.prenom} ${user.nom}`;

//         // Couleur du tag selon fonction
//         const fonctionTagColor = user.fonction_id === 1 ? "blue" : "green";

//         return (
//           <Space direction="vertical" size={2}>
//             <Tag color={fonctionTagColor}>{fullName}</Tag>
//             {agence && <Tag color="orange">{agence.nom}</Tag>}
//           </Space>
//         );
//       },
//     },
//     {
//       title: "REFERENCE",
//       dataIndex: "ref_commande",
//       key: "ref_commande",
//       align: "center",
//       filterDropdown: ({
//         setSelectedKeys,
//         selectedKeys,
//         confirm,
//         clearFilters,
//       }) => (
//         <div style={{ padding: 8 }}>
//           <Input
//             placeholder="Rechercher..."
//             value={selectedKeys[0]}
//             onChange={(e) =>
//               setSelectedKeys(e.target.value ? [e.target.value] : [])
//             }
//             onPressEnter={() => confirm()}
//             style={{ marginBottom: 8, display: "block" }}
//           />
//           <Space>
//             <Button type="primary" onClick={() => confirm()} size="small">
//               Rechercher
//             </Button>
//             <Button onClick={() => clearFilters()} size="small">
//               Réinitialiser
//             </Button>
//           </Space>
//         </div>
//       ),
//       onFilter: (value, record) =>
//         record.ref_commande?.toLowerCase().includes(value.toLowerCase()),

//       filterIcon: (filtered) => (
//         <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
//       ),
//       render: (_, record) => <span>{record.ref_commande}</span>,
//     },
//     {
//       title: "REFERENCE FACTURE",
//       dataIndex: "ref_facture",
//       key: "ref_facture",
//       align: "center",

//       /** ✅ Filtre Select searchable */
//       filterDropdown: ({
//         setSelectedKeys,
//         selectedKeys,
//         confirm,
//         clearFilters,
//       }) => {
//         /** 🔥 Liste unique des références */
//         const refs = [
//           ...new Set(listeCommandes.map((f) => f.ref_facture).filter(Boolean)),
//         ];

//         return (
//           <div style={{ padding: 10, width: 250 }}>
//             {/* 🔍 Select recherche */}
//             <Select
//               showSearch
//               placeholder="Choisir une référence..."
//               style={{ width: "100%" }}
//               value={selectedKeys[0] || undefined}
//               options={refs.map((ref) => ({
//                 value: ref,
//                 label: ref,
//               }))}
//               /** Recherche dans la liste */
//               filterOption={(input, option) =>
//                 option.label.toLowerCase().includes(input.toLowerCase())
//               }
//               /** Quand on sélectionne */
//               onChange={(value) => {
//                 setSelectedKeys(value ? [value] : []);
//                 confirm();
//               }}
//               allowClear
//             />

//             {/* 🔄 Reset */}
//             <Button
//               style={{ marginTop: 10, width: "100%" }}
//               onClick={() => {
//                 clearFilters();
//                 confirm();
//               }}
//             >
//               Réinitialiser
//             </Button>
//           </div>
//         );
//       },

//       /** 🎯 Filtrage exact */
//       onFilter: (value, record) => record.ref_facture === value,

//       /** 🔍 Icône filtre */
//       filterIcon: (filtered) => (
//         <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
//       ),

//       /** ✅ Affichage */
//       render: (_, record) => <span>{record.ref_facture || "-"}</span>,
//     },
//     {
//       title: "Compagnie",
//       dataIndex: "compagnie",
//       key: "compagnie",
//       align: "center",
//     },
//     {
//       title: "Agence",
//       dataIndex: "agence",
//       key: "agence",
//       align: "center",
//       filterDropdown: ({
//         setSelectedKeys,
//         selectedKeys,
//         confirm,
//         clearFilters,
//       }) => (
//         <div style={{ padding: 8 }}>
//           <Input
//             placeholder="Rechercher..."
//             value={selectedKeys[0]}
//             onChange={(e) =>
//               setSelectedKeys(e.target.value ? [e.target.value] : [])
//             }
//             onPressEnter={() => confirm()}
//             style={{ marginBottom: 8, display: "block" }}
//           />
//           <Space>
//             <Button type="primary" onClick={() => confirm()} size="small">
//               Rechercher
//             </Button>
//             <Button onClick={() => clearFilters()} size="small">
//               Réinitialiser
//             </Button>
//           </Space>
//         </div>
//       ),
//       onFilter: (value, record) =>
//         record.agence?.toLowerCase().includes(value.toLowerCase()),

//       filterIcon: (filtered) => (
//         <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
//       ),
//       render: (_, record) => <span>{record.agence}</span>,
//     },
//     {
//       title: "Status",
//       dataIndex: "statut_commande",
//       key: "statut_commande",
//       filters: [
//         { text: "Validé par Masoandro", value: "valide_direction" },
//         { text: "Refusé par Masoandro", value: "invalide_direction" },
//         {
//           text: "En attente de validation Masoandro",
//           value: "attente_masoandro",
//         },
//         { text: "En attente de validation Client", value: "attente_client" },
//         { text: "Validé par le client", value: "valide_client" },
//         { text: "Refusé par le client", value: "invalide_client" },
//       ],
//       onFilter: (value, record) => record.statut_commande === value,
//       render: (status) => {
//         let color = "default";
//         let text = status;

//         switch (status) {
//           case "valide_direction":
//             color = "green"; // validé Masoandro → vert
//             text = "Validé par Masoandro";
//             break;
//           case "invalide_direction":
//             color = "red"; // refusé Masoandro → rouge
//             text = "Refusé par Masoandro";
//             break;
//           case "attente_masoandro":
//             color = "orange"; // en attente Masoandro → orange
//             text = "En attente de validation Masoandro";
//             break;
//           case "attente_client":
//             color = "blue"; // en attente client → bleu
//             text = "En attente de validation Client";
//             break;
//           case "valide_client":
//             color = "cyan"; // validé client → cyan clair
//             text = "Validé par le client";
//             break;
//           case "invalide_client":
//             color = "magenta"; // refusé client → magenta / rose
//             text = "Refusé par le client";
//             break;
//           default:
//             color = "default";
//             text = "Inconnu";
//         }

//         return <Tag color={color}>{text}</Tag>;
//       },
//     },
//     {
//       title: "Action",
//       key: "action",
//       render: (_, record) => (
//         <Space size="middle">
//           {hasPermission(getPermissionsFromToken(), "COMMANDE_VIEW") && (
//             <Button
//               className="btn btn-info btn-sm"
//               onClick={() => handlegetcommandeyid(record)}
//               title="Voir la  commande"
//             >
//               <EyeOutlined />
//             </Button>
//           )}

//           {hasPermission(
//             getPermissionsFromToken(),
//             "COMMANDE_CHANGE_STATUS",
//           ) && (
//               <Button
//                 className="btn btn-success btn-sm"
//                 onClick={() => openValidationModal(record)}
//                 title="Valider la commande"
//               >
//                 <CheckOutlined />
//               </Button>
//             )}

//           {hasPermission(getPermissionsFromToken(), "COMMANDE_DOWNLOAD") &&
//             record.statut_commande !== "attente_masoandro" && (
//               <Button
//                 onClick={() => handleDownload(record)}
//                 className="btn btn-secondary btn-sm"
//                 title="Télécharger le bon de commande"
//               >
//                 <FilePdfOutlined />
//               </Button>
//             )}

//           {/* {
//                         hasPermission(getPermissionsFromToken(), "COMMANDE_DOWNLOAD") && <Button
//                             onClick={() => handleDownload(record)}
//                             className="btn btn-secondary btn-sm"
//                             title="Télécharger le bon de commande"
//                         >
//                             <FilePdfOutlined />
//                         </Button>
//                     } */}
//         </Space>
//       ),
//     },
//   ];

//   const handleTableChange = (pag, filters, sorter) => {
//     setPagination(pag);
//     setTableFilters(filters);
//   };

//   const handleCloseShowModal = () => {
//     setshowmodaldetail(false);
//     setselectedCommandes({});
//     setCurrentStep(1);
//   };

//   const handleDownload = async (record) => {
//     try {
//       console.log(record);
//       await downloadCommande(record.commande_id);
//     } catch (error) {
//       if (error.code === "ERR_NETWORK") {
//         setnotif({
//           ...notif,
//           message: "Commande telecharger avec succés",
//           info: "success",
//         });
//         setshowToast(true);
//       } else {
//         throw error;
//       }
//     }
//   };

//   const updateField = (field, value) => {
//     setselectedCommandes((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const updateAdditionalField = (id, field, value) => {
//     setselectedCommandes((prev) => ({
//       ...prev,
//       additional: prev.additional.map((item) =>
//         item.id === id ? { ...item, [field]: value } : item,
//       ),
//     }));
//   };

//   const handleUpdate = async () => {
//     const res = await update_commande(selectedCommandes);
//     if (res.status === "success") {
//       setnotif({
//         ...notif,
//         message: "Bon de commande modifié  avec succés",
//         info: "success",
//       });
//       setshowToast(true);
//       setTimeout(() => {
//         window.location.reload();
//       }, 1500);
//     } else {
//       message.warning(
//         "Erreur lors de la modification des bons de commandes !!!",
//       );
//       setnotif({
//         ...notif,
//         message: "Erreur lors de la modification bon de commandes !!!",
//         info: "error",
//       });
//       setshowToast(true);
//       setTimeout(() => {
//         setshowToast(false);
//       }, 1500);
//     }
//   };

//   const handleValidateCommande = async () => {
//     const res = await toggle_commande(
//       selectedCommandes.commande_id,
//       selectedCommandes.statut_commande,
//     );
//     if (res.status === "success") {
//       setnotif({
//         ...notif,
//         message: "Bon de commande validé  avec succés",
//         info: "success",
//       });
//       setshowToast(true);
//       setTimeout(() => {
//         window.location.reload();
//       }, 1500);
//     } else {
//       message.warning("Erreur lors de la validation des bons de commandes !!!");
//       setnotif({
//         ...notif,
//         message: "Erreur lors de la validation bon de commandes !!!",
//         info: "error",
//       });
//       setshowToast(true);
//       setTimeout(() => {
//         setshowToast(false);
//       }, 1500);
//     }
//   };

//   const handleExport = async () => {
//     const params = new URLSearchParams();

//     if (dateRange.length === 2) {
//       params.append(
//         "start",
//         moment(dateRange[0]).format("YYYY-MM-DD HH:mm:ss"),
//       );
//       params.append("end", moment(dateRange[1]).format("YYYY-MM-DD HH:mm:ss"));
//     } else {
//       // Si pas de date sélectionnée, 3 derniers mois par défaut
//       params.append("end", moment().format("YYYY-MM-DD HH:mm:ss"));
//       params.append(
//         "start",
//         moment().subtract(3, "months").format("YYYY-MM-DD HH:mm:ss"),
//       );
//     }
//     const res = await export_commandes(params.toString());
//   };

//   const onAddBc = async () => {
//     setshowModalAdd(true);
//   };

//   const [lignes, setLignes] = useState([
//     { nom: "", reference: "", qte: 1, prix_unitaire: 0 },
//   ]);

//   const addLigne = () => {
//     setLignes([
//       ...lignes,
//       { nom: "", reference: "", qte: 1, prix_unitaire: 0 },
//     ]);
//   };

//   const removeLigne = (index) => {
//     const newLignes = [...lignes];
//     newLignes.splice(index, 1);
//     setLignes(newLignes);
//   };

//   const updateLigne = (index, field, value) => {
//     const newLignes = [...lignes];
//     newLignes[index][field] = value;
//     setLignes(newLignes);
//   };

//   const updateCamionField = (index, field, value) => {
//     setSelectedCamion((prev) =>
//       prev.map((item, i) => (i === index ? { ...item, [field]: value } : item)),
//     );
//   };

//   const onSubmit = async () => {
//     setLoading(true);
//     console.log(selectedCamion);
//     const payload = {
//       lignes,
//       factures_id: selectedFactures,
//       camions: selectedCamion,
//     };
//     const res = await create_additionnal_commande(payload);
//     if (res.status === "success") {
//       setnotif({
//         ...notif,
//         message: "Bon de commande créé avec succès",
//         info: "success",
//       });
//       setshowToast(true);
//       setTimeout(() => {
//         window.location.reload();
//       }, 1500);
//     } else {
//       message.warning("Erreur lors de la création du bon de commande !!!");
//       setnotif({
//         ...notif,
//         message: "Erreur lors de la création du bon de commande !!!",
//         info: "error",
//       });
//       setshowToast(true);
//       setTimeout(() => {
//         setshowToast(false);
//       }, 1500);
//     }
//   };

//   const onFactureChanged = (value) => {
//     console.log(value);
//     console.log(listeFactures);
//     const coef_vide = value
//       ? listeFactures.find((f) => f.id === value)?.coefficient_vide
//       : 0;
//     const coef_charge = value
//       ? listeFactures.find((f) => f.id === value)?.coefficient_charge
//       : 0;
//     console.log(coef_vide, coef_charge);
//     updateCamionField(0, "coefficient_vide", coef_vide);
//     updateCamionField(0, "coefficient_charge", coef_charge);
//     setselectedFactures(value);
//   };

//   return (
//     <div className="p-0">
//       <div className="flex justify-between items-center mb-4">
//         <Space style={{ width: "85%" }}>
//           <Input
//             placeholder="🔍 Rechercher..."
//             value={searchText}
//             onChange={handleSearch}
//             prefix={<SearchOutlined />}
//             style={{ width: 250 }}
//           />
//           <RangePicker showTime onChange={handleDateChange} size="small" />
//           <Button
//             icon={<ReloadOutlined />}
//             onClick={() => fetchCommandes(dateRange)}
//             loading={loading}
//             style={{
//               backgroundColor: "#0d6efd",
//               borderColor: "#0d6efd",
//               color: "#fff",
//             }}
//           >
//             Recharger
//           </Button>
//           {hasPermission(
//             getPermissionsFromToken(),
//             "COMMANDE_ADD_ADDITIONNAL",
//           ) && (
//               <Button
//                 icon={<PlusOutlined />}
//                 onClick={onAddBc}
//                 loading={loading}
//                 style={{
//                   backgroundColor: "#109b3f",
//                   borderColor: "#109b3f",
//                   color: "#fff",
//                 }}
//               >
//                 Ajouter
//               </Button>
//             )}
//         </Space>
//         {hasPermission(getPermissionsFromToken(), "COMMANDE_EXPORT") && (
//           <Button
//             icon={<PlusOutlined />}
//             style={{
//               backgroundColor: "#198754",
//               borderColor: "#198754",
//               color: "#fff",
//             }}
//             onClick={handleExport}
//           >
//             Exporter
//           </Button>
//         )}
//       </div>
//       <Spin spinning={loading}>
//         <div
//           style={{
//             height: "70vh",
//             overflowY: "auto",
//           }}
//         >
//           <Table
//             rowKey="id"
//             columns={columns_commandes}
//             dataSource={filteredCommandes}
//             loading={loading}
//             pagination={{
//               pageSize: 10,
//               position: ["bottomCenter"],
//               className: "custom-pagination",
//               style: {
//                 display: "flex",
//                 justifyContent: "center",
//                 marginTop: 12,
//               },
//               itemRender: (page, type, originalElement) => {
//                 if (type === "page") {
//                   return (
//                     <div
//                       style={{
//                         borderRadius: "50%",
//                         minWidth: 32,
//                         height: 32,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         border: "1px solid #d9d9d9",
//                       }}
//                     >
//                       {page}
//                     </div>
//                   );
//                 }
//                 return originalElement;
//               },
//             }}
//             onChange={handleTableChange}
//             rowSelection={rowSelection} // ✅ ajouté ici
//           />
//         </div>
//       </Spin>
//       {showToast && (
//         <Notification message={notif.message} status={notif.info} />
//       )}

//       <Modal
//         // title={
//         //   <span style={{ fontSize: 18, fontWeight: 600 }}>
//         //     Détails de la commande {selectedCommandes.ref_commande || ""}
//         //   </span>
//         // }
//         title={
//           <span style={{ fontSize: 18, fontWeight: 600 }}>
//             Détails de la commande {selectedCommandes.ref_commande || ""}
//             {isCommandeLocked && (
//               <Tag color="green" style={{ marginLeft: 10 }}>
//                 Validé — lecture seule
//               </Tag>
//             )}
//           </span>
//         }
//         open={showmodaldetail}
//         onCancel={handleCloseShowModal}
//         width="55%"
//         style={{ top: 10 }}
//         bodyStyle={{ background: "#fafafa", paddingBottom: 10 }}
//         // footer={[
//         //   <Button key="cancel" onClick={handleCloseShowModal}>
//         //     Annuler
//         //   </Button>,
//         //   currentStep === 1 && (
//         //     <Button key="next" type="primary" onClick={() => setCurrentStep(2)}>
//         //       Suivant
//         //     </Button>
//         //   ),
//         //   currentStep === 2 && (
//         //     <>
//         //       <Button key="prev" onClick={() => setCurrentStep(1)}>
//         //         Précédent
//         //       </Button>
//         //       <Button
//         //         key="confirm"
//         //         type="primary"
//         //         onClick={() => handleUpdate()}
//         //       >
//         //         Confirmer
//         //       </Button>
//         //     </>
//         //   ),
//         // ]}
//         footer={[
//           <Button key="cancel" onClick={handleCloseShowModal}>
//             Annuler
//           </Button>,
//           currentStep === 1 && (
//             <Button key="next" type="primary" onClick={() => setCurrentStep(2)}>
//               Suivant
//             </Button>
//           ),
//           currentStep === 2 && (
//             <>
//               <Button key="prev" onClick={() => setCurrentStep(1)}>
//                 Précédent
//               </Button>
//               {!isCommandeLocked && (
//                 <Button key="confirm" type="primary" onClick={() => handleUpdate()}>
//                   Confirmer
//                 </Button>
//               )}
//             </>
//           ),
//         ]}
//       >
//         {currentStep === 1 && (
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(2, 1fr)",
//               gap: "12px 32px",
//               marginBottom: 25,
//               background: "#fff",
//               padding: "16px 20px",
//               borderRadius: 12,
//               boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
//             }}
//           >
//             {/* Agence */}
//             <div>
//               <label style={{ fontWeight: 500 }}>Agence</label>
//               <Input
//                 value={selectedCommandes.agence || ""}
//                 onChange={(e) => updateField("agence", e.target.value)}
//               />
//             </div>

//             {/* Compagnie */}
//             <div>
//               <label style={{ fontWeight: 500 }}>Compagnie</label>
//               <Input
//                 value={selectedCommandes.compagnie || ""}
//                 onChange={(e) => updateField("compagnie", e.target.value)}
//               />
//             </div>

//             {/* Camion */}
//             <div>
//               <label style={{ fontWeight: 500 }}>Camion</label>
//               <Input
//                 value={selectedCommandes.ref_camion || ""}
//                 onChange={(e) => updateField("ref_camion", e.target.value)}
//               />
//             </div>

//             {/* Remorque */}
//             <div>
//               <label style={{ fontWeight: 500 }}>Remorque</label>
//               <Input
//                 value={selectedCommandes.imm_remorque || ""}
//                 onChange={(e) => updateField("imm_remorque", e.target.value)}
//               />
//             </div>

//             {/* Chauffeur */}
//             <div>
//               <label style={{ fontWeight: 500 }}>Chauffeur</label>
//               <Select
//                 value={selectedCommandes.chauffeur_commande}
//                 onChange={(value) => updateField("chauffeur_commande", value)}
//                 style={{ width: "100%" }}
//               >
//                 {listeChauffeur?.map((item) => (
//                   <Select.Option key={item.id} value={item.id}>
//                     {item.prenom}
//                   </Select.Option>
//                 ))}
//               </Select>
//             </div>

//             {/* Observation */}
//             <div style={{ gridColumn: "1 / 3" }}>
//               <label style={{ fontWeight: 500 }}>Observation</label>
//               <Input.TextArea
//                 value={selectedCommandes.observation || ""}
//                 onChange={(e) => updateField("observation", e.target.value)}
//                 rows={2}
//               />
//             </div>

//             {/* Date départ */}
//             <div>
//               <label style={{ fontWeight: 500 }}>Date de départ</label>
//               <Input
//                 type="date"
//                 value={selectedCommandes.date_depart?.substring(0, 10)}
//                 onChange={(e) => updateField("date_depart", e.target.value)}
//               />
//             </div>

//             {/* Date arrivée */}
//             <div>
//               <label style={{ fontWeight: 500 }}>Date d'arrivée</label>
//               <Input
//                 type="date"
//                 value={selectedCommandes.date_arrive?.substring(0, 10)}
//                 onChange={(e) => updateField("date_arrive", e.target.value)}
//               />
//             </div>
//           </div>
//         )}

//         {currentStep === 2 && (
//           <div
//             style={{
//               background: "#fff",
//               padding: "6px 0",
//               borderRadius: 12,
//               boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
//             }}
//           >
//             <div
//               style={{
//                 fontWeight: 600,
//                 marginBottom: 10,
//                 paddingLeft: 16,
//                 fontSize: 16,
//               }}
//             >
//               Charges du transport
//             </div>

//             <Table
//               dataSource={dataSource}
//               columns={columns}
//               pagination={{
//                 pageSize: 10,
//                 position: ["bottomCenter"],
//                 className: "custom-pagination",
//                 style: {
//                   display: "flex",
//                   justifyContent: "center",
//                   marginTop: 12,
//                 },
//                 itemRender: (page, type, originalElement) => {
//                   if (type === "page") {
//                     return (
//                       <div
//                         style={{
//                           borderRadius: "50%",
//                           minWidth: 32,
//                           height: 32,
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           border: "1px solid #d9d9d9",
//                         }}
//                       >
//                         {page}
//                       </div>
//                     );
//                   }
//                   return originalElement;
//                 },
//               }}
//               size="small"
//               bordered={false}
//               rowClassName={(_, index) =>
//                 index % 2 === 0 ? "table-row-light" : "table-row-dark"
//               }
//               style={{
//                 borderRadius: 12,
//                 overflow: "hidden",
//               }}
//               footer={() => (
//                 <div style={{ textAlign: "right", marginTop: 12 }}>
//                   <strong>Total: {totalGeneral.toLocaleString()} Ar</strong>
//                 </div>
//               )}
//             />
//           </div>
//         )}
//       </Modal>

//       <Modal
//         title={`Valider la commande ${selectedCommandes?.ref_commande || ""}`}
//         open={validationModalVisible}
//         onCancel={closeValidationModal}
//         footer={[
//           <Button key="cancel" onClick={closeValidationModal}>
//             Annuler
//           </Button>,
//           <Button key="confirm" type="primary" onClick={handleValidateCommande}>
//             Confirmer
//           </Button>,
//         ]}
//       >
//         <Row>
//           <Col span={6}>
//             <p>Choisir le statut :</p>
//           </Col>
//           <Col span={18} style={{ padding: 10 }}>
//             <Select
//               size="large"
//               value={selectedCommandes.statut_commande}
//               onChange={(val) => {
//                 updateField("statut_commande", val);
//               }}
//               style={{ width: "100%", textAlign: "center" }}
//             >
//               <Option value="valide_direction">Validé par Masoandro</Option>
//               <Option value="invalide_direction">Invalidé par Masoandro</Option>
//               <Option value="attente_masoandro">
//                 En attente de validation Masoandro
//               </Option>
//             </Select>
//           </Col>
//         </Row>
//       </Modal>

//       <Modal
//         title="Création de la commande"
//         open={showModalAdd}
//         onCancel={() => setshowModalAdd(false)}
//         width={1000} // un peu plus large pour tout tenir
//         footer={[
//           <Button key="cancel" onClick={() => setshowModalAdd(false)}>
//             Annuler
//           </Button>,
//           <Button key="confirm" type="primary" onClick={onSubmit}>
//             Créer
//           </Button>,
//         ]}
//       >
//         {/* FACTURES */}
//         <div style={{ marginBottom: 20 }}>
//           <Text strong>Factures liées</Text>
//           <Select
//             showSearch
//             // mode="multiple"
//             style={{ width: "100%", marginTop: 5 }}
//             placeholder="Sélectionner les factures"
//             value={selectedFactures}
//             onChange={(value) => {
//               onFactureChanged(value);
//             }}
//           >
//             {listeFactures &&
//               listeFactures?.map((f) => (
//                 <Option key={f.id} value={f.id}>
//                   {f.ref_facture || `Facture #${f.id}`}
//                 </Option>
//               ))}
//           </Select>
//         </div>

//         <div>
//           {selectedCamion &&
//             selectedCamion.map((item, index) => (
//               <div
//                 key={index}
//                 style={{
//                   border: "1px solid #e5e5e5",
//                   borderRadius: 8,
//                   padding: 15,
//                   marginBottom: 20,
//                   background: "#fafafa",
//                 }}
//               >
//                 {/* Ligne Camion + Coeffs */}
//                 <Row gutter={12} align="middle">
//                   <Col span={6}>
//                     <Select
//                       size="large"
//                       placeholder="Choisir camion"
//                       style={{ ...commonInputStyle, marginTop: 25 }}
//                       value={item.camion_id}
//                       onChange={(val) => {
//                         const camion = listeCamions.find((c) => c.id === val);
//                         updateCamionField(index, "camion_id", val);
//                         if (camion?.chauffeur_id) {
//                           updateCamionField(
//                             index,
//                             "chauffeur_id",
//                             camion.chauffeur_id,
//                           );
//                         }
//                       }}
//                     >
//                       {listeCamions?.map((c) => (
//                         <Option key={c.id} value={c.id}>
//                           {c.imm}
//                         </Option>
//                       ))}
//                     </Select>
//                   </Col>

//                   <Col span={6}>
//                     <Select
//                       size="large"
//                       placeholder="Choisir chauffeur"
//                       style={{
//                         ...commonInputStyle,
//                         marginTop: 25,
//                         textAlign: "center",
//                       }}
//                       value={item.chauffeur_id}
//                       onChange={(val) =>
//                         updateCamionField(index, "chauffeur_id", val)
//                       }
//                     >
//                       {listeChauffeur?.map((c) => (
//                         <Option key={c.id} value={c.id}>
//                           {c.prenom}
//                         </Option>
//                       ))}
//                     </Select>
//                   </Col>

//                   <Col span={4} style={{ textAlign: "center" }}>
//                     <span style={{ fontWeight: 500 }}>Coeff chargé</span>
//                     <Input
//                       value={item.coefficient_charge ?? ""}
//                       onChange={(e) =>
//                         updateCamionField(
//                           index,
//                           "coefficient_charge",
//                           e.target.value,
//                         )
//                       }
//                       style={{
//                         ...commonInputStyle,
//                         paddingTop: 10,
//                         background: "#fff",
//                       }}
//                       placeholder="ex: 0.3"
//                     />
//                   </Col>

//                   <Col span={4} style={{ textAlign: "center" }}>
//                     <span style={{ fontWeight: 500 }}>Coeff vide</span>
//                     <Input
//                       value={item.coefficient_vide ?? ""}
//                       onChange={(e) =>
//                         updateCamionField(
//                           index,
//                           "coefficient_vide",
//                           e.target.value,
//                         )
//                       }
//                       style={{
//                         ...commonInputStyle,
//                         paddingTop: 10,
//                         background: "#fff",
//                       }}
//                       placeholder="ex: 0.3"
//                     />
//                   </Col>
//                 </Row>

//                 {/* Ligne compagnie + agence */}
//                 <Row gutter={12} style={{ marginTop: 15 }} align="middle">
//                   <Col span={12}>
//                     <label style={{ fontWeight: 500 }}>Compagnie</label>
//                     <Input
//                       placeholder="Nom de la compagnie"
//                       value={item.compagnie}
//                       onChange={(e) =>
//                         updateCamionField(index, "compagnie", e.target.value)
//                       }
//                       style={{ marginTop: 5 }}
//                     />
//                   </Col>

//                   <Col span={12}>
//                     <label style={{ fontWeight: 500 }}>Agence</label>
//                     <Input
//                       placeholder="Agence"
//                       value={item.agence}
//                       onChange={(e) =>
//                         updateCamionField(index, "agence", e.target.value)
//                       }
//                       style={{ marginTop: 5 }}
//                     />
//                   </Col>
//                 </Row>

//                 {/* Observation */}
//                 <Row style={{ marginTop: 15 }}>
//                   <Col span={24}>
//                     <TextArea
//                       rows={3}
//                       placeholder="Observation"
//                       value={item.observation}
//                       onChange={(e) =>
//                         updateCamionField(index, "observation", e.target.value)
//                       }
//                     />
//                   </Col>
//                 </Row>
//               </div>
//             ))}
//         </div>
//         <Divider />

//         {/* HEADER */}
//         <Row gutter={8} style={{ marginBottom: 8 }}>
//           <Col span={6}>
//             <Text strong>Désignation</Text>
//           </Col>
//           <Col span={4}>
//             <Text strong>Réf</Text>
//           </Col>
//           <Col span={3}>
//             <Text strong>Qté</Text>
//           </Col>
//           <Col span={5}>
//             <Text strong>Prix Unitaire</Text>
//           </Col>
//           <Col span={4}>
//             <Text strong>Total</Text>
//           </Col>
//           <Col span={2}></Col>
//         </Row>

//         {/* LIGNES */}
//         {lignes.map((ligne, index) => {
//           const totalLigne = (ligne.qte || 0) * (ligne.prix_unitaire || 0);

//           return (
//             <Row
//               key={index}
//               gutter={8}
//               align="middle"
//               style={{ marginBottom: 8 }}
//             >
//               {/* NOM */}
//               <Col span={6}>
//                 <Input
//                   placeholder="Désignation"
//                   value={ligne.nom}
//                   onChange={(e) => updateLigne(index, "nom", e.target.value)}
//                 />
//               </Col>

//               {/* REF */}
//               <Col span={4}>
//                 <Input
//                   placeholder="Réf"
//                   value={ligne.ref}
//                   onChange={(e) => updateLigne(index, "ref", e.target.value)}
//                 />
//               </Col>

//               {/* QTE */}
//               <Col span={3}>
//                 <InputNumber
//                   min={1}
//                   style={{ width: "100%" }}
//                   value={ligne.qte}
//                   onChange={(value) => updateLigne(index, "qte", value)}
//                 />
//               </Col>

//               {/* PRIX */}
//               <Col span={5}>
//                 <InputNumber
//                   min={0}
//                   style={{ width: "100%" }}
//                   value={ligne.prix_unitaire}
//                   onChange={(value) =>
//                     updateLigne(index, "prix_unitaire", value)
//                   }
//                 />
//               </Col>

//               {/* TOTAL */}
//               <Col span={4} style={{ textAlign: "right" }}>
//                 <Text>{totalLigne.toLocaleString()} Ar</Text>
//               </Col>

//               {/* ACTIONS */}
//               <Col span={2} style={{ display: "flex", gap: 5 }}>
//                 <Button icon={<PlusOutlined />} onClick={addLigne} />

//                 {lignes.length > 1 && (
//                   <Button
//                     danger
//                     icon={<MinusOutlined />}
//                     onClick={() => removeLigne(index)}
//                   />
//                 )}
//               </Col>
//             </Row>
//           );
//         })}

//         <Divider />

//         {/* TOTAL GLOBAL */}
//         <Row justify="end">
//           <Col>
//             <Text strong>
//               Total général :{" "}
//               {lignes
//                 .reduce((sum, l) => sum + l.qte * l.prix_unitaire, 0)
//                 .toLocaleString()}{" "}
//               Ar
//             </Text>
//           </Col>
//         </Row>
//       </Modal>
//     </div>
//   );
// };

// export default Commandes;

import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Modal,
  Space,
  message,
  Tag,
  Typography,
  Select,
  Row,
  Col,
  DatePicker,
  InputNumber,
  Tabs,
  Divider,
  Steps,
  Radio,
  Spin,
} from "antd";
import {
  PlusOutlined,
  ReloadOutlined,
  SearchOutlined,
  EyeOutlined,
  CheckOutlined,
  FilePdfOutlined,
  MinusOutlined,
} from "@ant-design/icons";
import {
  downloadCommande,
  get_commande,
  getall_commandes,
  update_commande,
  toggle_commande,
  export_commandes,
  create_commande,
  create_additionnal_commande,
} from "../../api/commandes";
import { getPermissionsFromToken, hasPermission } from "../../utils/utils";

import { get_ListeRegion } from "../../api/region";
import { get_all_agences, get_all_users } from "../../api/users";
import Notification from "../../composants/Notification";
import "moment/locale/fr";
import moment from "moment";
import { get_ListeClients } from "../../api/clients";
import { get_ListeChauffeur } from "../../api/chauffeur";
import { getall_facture } from "../../api/factures";
import { get_listeCamion } from "../../api/camion";
import { select } from "framer-motion/client";
const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;
const commonInputStyle = {
  width: "100%",
  height: 40,
  display: "flex",
  alignItems: "center",
};

const { TextArea } = Input;

const Commandes = () => {
  const [searchText, setSearchText] = useState("");
  const [dateRange, setDateRange] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCommandes, setselectedCommandes] = useState({});
  const [listeCommandes, setlisteCommandes] = useState([]);
  const [filteredCommandes, setfilteredCommandes] = useState([]);
  const [showToast, setshowToast] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [listeChauffeur, setlisteChauffeur] = useState([]);
  const [notif, setnotif] = useState({
    message: null,
    info: null,
  });
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
  const [tableFilters, setTableFilters] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); // pour stocker les IDs
  const rowSelection = {
    selectedRowKeys,
    onChange: (keys, rows) => {
      setSelectedRowKeys(keys);
      setSelectedRows(rows);
    },
    selections: [
      Table.SELECTION_ALL,
      Table.SELECTION_INVERT,
      Table.SELECTION_NONE,
    ],
  };
  const InfoItem = ({ label, value }) => (
    <div>
      <strong>{label} :</strong>{" "}
      <span style={{ opacity: 0.85 }}>{value || "-"}</span>
    </div>
  );
  const [showmodaldetail, setshowmodaldetail] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [validationModalVisible, setValidationModalVisible] = useState(false);

  const [showModalAdd, setshowModalAdd] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [listAgence, setListeAgence] = useState([]);
  const [listeUsers, setlisteUsers] = useState([]);
  const [listeFactures, setlisteFactures] = useState([]);
  const [selectedFactures, setselectedFactures] = useState({});
  const [selectedCamion, setSelectedCamion] = useState([
    {
      camion_id: null,
      chauffeur_id: null,
      coefficient_charge: "",
      coefficient_vide: "",
      compagnie: "COMPAGNIE MASOANDRO",
      agence: "Antananarivo",
      observation: "",
    },
  ]);
  const [listeCamions, setlisteCamions] = useState([]);

  // 🔒 Statuts pour lesquels le bon de commande devient en lecture seule
  const STATUTS_VERROUILLES = ["valide_direction", "valide_client"];
  const [isCommandeLocked, setIsCommandeLocked] = useState(false);

  useEffect(() => {
    fetchListeAgence();
    fetchUsers();
    fetchCommandes();
    fetchChauffeur();
    fetchFacture();
    fetchListeCamion();
  }, [selectedCommandes]);

  const fetchListeCamion = async () => {
    const res = await get_listeCamion();
    if (res.status === "success") {
      setlisteCamions(res.data);
    }
  };

  const fetchUsers = async () => {
    const res = await get_all_users();
    setlisteUsers(res.data);
  };

  const fetchFacture = async (range = []) => {
    try {
      setLoading(true);
      let start, end;
      if (range.length === 2) {
        start = moment(range[0]).format("YYYY-MM-DD HH:mm:ss");
        end = moment(range[1]).format("YYYY-MM-DD HH:mm:ss");
      } else {
        end = moment().format("YYYY-MM-DD HH:mm:ss");
        start = moment().subtract(6, "months").format("YYYY-MM-DD HH:mm:ss");
      }
      const res = await getall_facture({ start, end });
      console.log("---------------------");

      console.log(res.data);
      if (res.data && Array.isArray(res.data)) {
        console.log(res);
        setlisteFactures(res.data);
      } else {
        console.log("///////////////////////");
        message.warning("Aucune donnée trouvée.");
      }
    } catch (error) {
      message.error("Erreur lors du chargement des factures");
    } finally {
      setLoading(false);
    }
  };

  const fetchListeAgence = async () => {
    const res = await get_all_agences();
    if (res.status === "success") {
      setListeAgence(res.data);
    }
  };

  const [loading, setLoading] = useState(false);

  const charges =
    selectedCommandes.additional?.length > 0
      ? []
      : [
        {
          name: "Carburant Trajet Aller",
          qtyField: "carburant_aller",
          priceField: "prix_go",
        },
        {
          name: "Carburant Trajet Retour",
          qtyField: "carburant_retour",
          priceField: "prix_go",
        },
        {
          name: "Perdiem Chauffeur",
          qtyField: "perdiem_chauffeur_multi",
          priceField: "perdiem_chauffeur",
        },
        {
          name: "Perdiem Aide-Chauffeur",
          qtyField: "perdiem_aide_multi",
          priceField: "perdiem_aide",
        },
        {
          name: "Crédit de communication",
          qtyField: "credit_multi",
          priceField: "credit",
        },
        {
          name: "Parking",
          qtyField: "parking_multi",
          priceField: "parking",
        },
        {
          name: "Fiche de Contravention",
          qtyField: "contravention_multi",
          priceField: "contravention",
        },
        {
          name: "Droit de Chargement",
          qtyField: "chargement_multi",
          priceField: "chargement",
        },

        {
          name: "Déchargement",
          qtyField: "dechargement_multi",
          priceField: "dechargement",
        },
        {
          name: "Arrimage",
          qtyField: "arrimage_multi",
          priceField: "arrimage",
        },
        {
          name: "Divers",
          qtyField: "divers_multi",
          priceField: "divers",
        },
      ];

  const dataSource =
    selectedCommandes?.additional?.length > 0
      ? // ── Mode additional : on mappe sur les lignes additional ──
      selectedCommandes.additional.map((item, index) => {
        const qty = Number(item.qte) || 1;
        const unitPrice = Number(item.prix_unitaire) || 0;
        return {
          key: index,
          name: item.nom,
          qty,
          unitPrice,
          total: qty * unitPrice,
          qtyField: "qte",
          priceField: "prix_unitaire",
          id: item.id, // utile pour updateAdditionalRow
        };
      })
      : // ── Mode standard : on mappe sur la définition CHARGES_DEF ──
      charges.map((item, index) => {
        const qty = item.qtyField
          ? Number(selectedCommandes[item.qtyField])
          : 1;
        const unitPrice = Number(selectedCommandes[item.priceField]) || 0;
        return {
          key: index,
          name: item.name,
          qty,
          unitPrice,
          total: qty * unitPrice,
          qtyField: item.qtyField,
          priceField: item.priceField,
        };
      });

  const totalGeneral = dataSource.reduce((sum, item) => sum + item.total, 0);

  const columns = [
    { title: "DESIGNATION", dataIndex: "name", key: "name" },

    {
      title: "QUANTITE",
      dataIndex: "qty",
      key: "qty",
      align: "right",
      render: (value, record) => (
        <Input
          disabled={isCommandeLocked}
          style={{ width: 80, textAlign: "right" }}
          value={value}
          onChange={(e) => {
            if (selectedCommandes.additional?.length > 0) {
              updateAdditionalField(record.id, "qte", e.target.value);
            } else {
              updateField(record.qtyField, Number(e.target.value));
            }
          }}
        />
      ),
    },

    {
      title: "PRIX UNITAIRE",
      dataIndex: "unitPrice",
      key: "unitPrice",
      align: "right",
      render: (value, record) => (
        <Input
          disabled={isCommandeLocked}
          style={{ width: 120, textAlign: "right" }}
          value={value}
          onChange={(e) => {
            if (selectedCommandes.additional?.length > 0) {
              updateAdditionalField(record.id, "prix_unitaire", e.target.value);
            } else {
              updateField(record.priceField, Number(e.target.value));
            }
          }}
        />
      ),
    },

    {
      title: "MONTANT",
      dataIndex: "total",
      key: "total",
      align: "right",
      render: (val) => val.toLocaleString(),
    },
  ];

  const fetchCommandes = async (range = []) => {
    try {
      setLoading(true);
      let start, end;
      if (range.length === 2) {
        start = moment(range[0]).format("YYYY-MM-DD HH:MM:SS");
        end = moment(range[1]).format("YYYY-MM-DD");
      } else {
        end = moment().format("YYYY-MM-DD");
        start = moment().subtract(3, "months").format("YYYY-MM-DD HH:MM:SS");
      }
      const res = await getall_commandes({ start, end });
      console.log(res);
      if (res.data && Array.isArray(res.data)) {
        setlisteCommandes(res.data);
        setfilteredCommandes(res.data);
      } else {
        message.warning("Aucune donnée trouvée.");
      }
    } catch (error) {
      message.error("Erreur lors du chargement des devis");
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    const filtered = listeCommandes.filter((item) => {
      const ref = item.ref?.toLowerCase?.() || "";
      const desc = item.description?.toLowerCase?.() || "";
      const client = item.client_nom?.toLowerCase?.() || "";
      return (
        ref.includes(value) || desc.includes(value) || client.includes(value)
      );
    });
    setfilteredCommandes(filtered);
  };

  const fetchChauffeur = async () => {
    const res = await get_ListeChauffeur();
    setlisteChauffeur(res.data || []);
  };

  const handleDateChange = (dates) => {
    setDateRange(dates);
  };

  const handlegetcommandeyid = async (record) => {
    const res = await get_commande(record.commande_id);
    console.log(res.data);
    // On fusionne avec le statut de la ligne cliquée : c'est la source la
    // plus fiable au moment du clic (la réponse de l'API peut ne pas
    // renvoyer statut_commande, ou renvoyer une valeur périmée).
    setselectedCommandes({
      ...res.data,
      statut_commande: record.statut_commande,
    });
    setIsCommandeLocked(STATUTS_VERROUILLES.includes(record.statut_commande));
    setshowmodaldetail(true);
  };

  const openValidationModal = (record) => {
    console.log(record);
    setselectedCommandes(record);
    setValidationModalVisible(true);
  };

  const closeValidationModal = () => {
    setselectedCommandes({});
    setValidationModalVisible(false);
  };

  const columns_commandes = [
    {
      title: "Id",
      dataIndex: "commande_id",
      key: "commande_id",
      // width: "50%",
    },
    {
      title: "Date",
      dataIndex: "create_at",
      key: "create_at",
      align: "center",
      render: (text) =>
        new Date(text).toISOString().slice(0, 19).replace("T", " "),
    },
    {
      title: "Type",
      dataIndex: "entretien_id",
      key: "type",
      width: 120,
      align: "center",
      filters: [
        { text: "Opération", value: 0 },
        { text: "Entretien", value: 1 },
      ],
      onFilter: (value, record) =>
        value === 0
          ? record.entretien_id === 0 || record.entretien_id === null
          : record.entretien_id !== 0 && record.entretien_id !== null,
      render: (entretien_id) => (
        <Tag
          color={entretien_id === 0 || entretien_id === null ? "cyan" : "green"}
        >
          {entretien_id === 0 || entretien_id === null
            ? "Opération"
            : "Entretien"}
        </Tag>
      ),
    },
    {
      title: "Utilisateur",
      dataIndex: "user_id",
      key: "user_id",
      align: "center",

      // 🔹 Filtre par agence
      filters: listAgence.map((a) => ({
        text: a.nom,
        value: `agence_${a.id}`, // on marque que c’est un filtre agence
      })),

      // 🔹 OnFilter pour gérer filtre combiné
      onFilter: (value, record) => {
        const user = listeUsers.find((u) => u.id === record.user_id);
        if (!user) return false;

        // Filtre par agence
        if (value.startsWith("agence_")) {
          const agenceId = Number(value.split("_")[1]);
          return user.agence_id === agenceId;
        }

        // Filtre par utilisateur
        return user.id === value;
      },

      // 🔹 Affichage + filtres utilisateurs (dynamique selon l’agence sélectionnée)
      render: (_, record) => {
        const user = listeUsers.find((u) => u.id === record.user_id);
        if (!user) return "—";

        const agence = listAgence.find((a) => a.id === user.agence_id);
        const fullName = `${user.prenom} ${user.nom}`;

        // Couleur du tag selon fonction
        const fonctionTagColor = user.fonction_id === 1 ? "blue" : "green";

        return (
          <Space direction="vertical" size={2}>
            <Tag color={fonctionTagColor}>{fullName}</Tag>
            {agence && <Tag color="orange">{agence.nom}</Tag>}
          </Space>
        );
      },
    },
    {
      title: "REFERENCE",
      dataIndex: "ref_commande",
      key: "ref_commande",
      align: "center",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Rechercher..."
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button type="primary" onClick={() => confirm()} size="small">
              Rechercher
            </Button>
            <Button onClick={() => clearFilters()} size="small">
              Réinitialiser
            </Button>
          </Space>
        </div>
      ),
      onFilter: (value, record) =>
        record.ref_commande?.toLowerCase().includes(value.toLowerCase()),

      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ),
      render: (_, record) => <span>{record.ref_commande}</span>,
    },
    {
      title: "REFERENCE FACTURE",
      dataIndex: "ref_facture",
      key: "ref_facture",
      align: "center",

      /** ✅ Filtre Select searchable */
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        /** 🔥 Liste unique des références */
        const refs = [
          ...new Set(listeCommandes.map((f) => f.ref_facture).filter(Boolean)),
        ];

        return (
          <div style={{ padding: 10, width: 250 }}>
            {/* 🔍 Select recherche */}
            <Select
              showSearch
              placeholder="Choisir une référence..."
              style={{ width: "100%" }}
              value={selectedKeys[0] || undefined}
              options={refs.map((ref) => ({
                value: ref,
                label: ref,
              }))}
              /** Recherche dans la liste */
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
              /** Quand on sélectionne */
              onChange={(value) => {
                setSelectedKeys(value ? [value] : []);
                confirm();
              }}
              allowClear
            />

            {/* 🔄 Reset */}
            <Button
              style={{ marginTop: 10, width: "100%" }}
              onClick={() => {
                clearFilters();
                confirm();
              }}
            >
              Réinitialiser
            </Button>
          </div>
        );
      },

      /** 🎯 Filtrage exact */
      onFilter: (value, record) => record.ref_facture === value,

      /** 🔍 Icône filtre */
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ),

      /** ✅ Affichage */
      render: (_, record) => <span>{record.ref_facture || "-"}</span>,
    },
    {
      title: "Compagnie",
      dataIndex: "compagnie",
      key: "compagnie",
      align: "center",
    },
    {
      title: "Agence",
      dataIndex: "agence",
      key: "agence",
      align: "center",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Rechercher..."
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button type="primary" onClick={() => confirm()} size="small">
              Rechercher
            </Button>
            <Button onClick={() => clearFilters()} size="small">
              Réinitialiser
            </Button>
          </Space>
        </div>
      ),
      onFilter: (value, record) =>
        record.agence?.toLowerCase().includes(value.toLowerCase()),

      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ),
      render: (_, record) => <span>{record.agence}</span>,
    },
    {
      title: "Status",
      dataIndex: "statut_commande",
      key: "statut_commande",
      filters: [
        { text: "Validé par Masoandro", value: "valide_direction" },
        { text: "Refusé par Masoandro", value: "invalide_direction" },
        {
          text: "En attente de validation Masoandro",
          value: "attente_masoandro",
        },
        { text: "En attente de validation Client", value: "attente_client" },
        { text: "Validé par le client", value: "valide_client" },
        { text: "Refusé par le client", value: "invalide_client" },
      ],
      onFilter: (value, record) => record.statut_commande === value,
      render: (status) => {
        let color = "default";
        let text = status;

        switch (status) {
          case "valide_direction":
            color = "green"; // validé Masoandro → vert
            text = "Validé par Masoandro";
            break;
          case "invalide_direction":
            color = "red"; // refusé Masoandro → rouge
            text = "Refusé par Masoandro";
            break;
          case "attente_masoandro":
            color = "orange"; // en attente Masoandro → orange
            text = "En attente de validation Masoandro";
            break;
          case "attente_client":
            color = "blue"; // en attente client → bleu
            text = "En attente de validation Client";
            break;
          case "valide_client":
            color = "cyan"; // validé client → cyan clair
            text = "Validé par le client";
            break;
          case "invalide_client":
            color = "magenta"; // refusé client → magenta / rose
            text = "Refusé par le client";
            break;
          default:
            color = "default";
            text = "Inconnu";
        }

        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {hasPermission(getPermissionsFromToken(), "COMMANDE_VIEW") && (
            <Button
              className="btn btn-info btn-sm"
              onClick={() => handlegetcommandeyid(record)}
              title="Voir la  commande"
            >
              <EyeOutlined />
            </Button>
          )}

          {hasPermission(
            getPermissionsFromToken(),
            "COMMANDE_CHANGE_STATUS",
          ) && (
              <Button
                className="btn btn-success btn-sm"
                onClick={() => openValidationModal(record)}
                title="Valider la commande"
              >
                <CheckOutlined />
              </Button>
            )}

          {hasPermission(getPermissionsFromToken(), "COMMANDE_DOWNLOAD") &&
            record.statut_commande !== "attente_masoandro" && (
              <Button
                onClick={() => handleDownload(record)}
                className="btn btn-secondary btn-sm"
                title="Télécharger le bon de commande"
              >
                <FilePdfOutlined />
              </Button>
            )}

          {/* {
                        hasPermission(getPermissionsFromToken(), "COMMANDE_DOWNLOAD") && <Button
                            onClick={() => handleDownload(record)}
                            className="btn btn-secondary btn-sm"
                            title="Télécharger le bon de commande"
                        >
                            <FilePdfOutlined />
                        </Button>
                    } */}
        </Space>
      ),
    },
  ];

  const handleTableChange = (pag, filters, sorter) => {
    setPagination(pag);
    setTableFilters(filters);
  };

  const handleCloseShowModal = () => {
    setshowmodaldetail(false);
    setselectedCommandes({});
    setCurrentStep(1);
    setIsCommandeLocked(false);
  };

  const handleDownload = async (record) => {
    try {
      console.log(record);
      await downloadCommande(record.commande_id);
    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        setnotif({
          ...notif,
          message: "Commande telecharger avec succés",
          info: "success",
        });
        setshowToast(true);
      } else {
        throw error;
      }
    }
  };

  const updateField = (field, value) => {
    setselectedCommandes((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const updateAdditionalField = (id, field, value) => {
    setselectedCommandes((prev) => ({
      ...prev,
      additional: prev.additional.map((item) =>
        item.id === id ? { ...item, [field]: value } : item,
      ),
    }));
  };

  const handleUpdate = async () => {
    const res = await update_commande(selectedCommandes);
    if (res.status === "success") {
      setnotif({
        ...notif,
        message: "Bon de commande modifié  avec succés",
        info: "success",
      });
      setshowToast(true);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      message.warning(
        "Erreur lors de la modification des bons de commandes !!!",
      );
      setnotif({
        ...notif,
        message: "Erreur lors de la modification bon de commandes !!!",
        info: "error",
      });
      setshowToast(true);
      setTimeout(() => {
        setshowToast(false);
      }, 1500);
    }
  };

  const handleValidateCommande = async () => {
    const res = await toggle_commande(
      selectedCommandes.commande_id,
      selectedCommandes.statut_commande,
    );
    if (res.status === "success") {
      setnotif({
        ...notif,
        message: "Bon de commande validé  avec succés",
        info: "success",
      });
      setshowToast(true);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      message.warning("Erreur lors de la validation des bons de commandes !!!");
      setnotif({
        ...notif,
        message: "Erreur lors de la validation bon de commandes !!!",
        info: "error",
      });
      setshowToast(true);
      setTimeout(() => {
        setshowToast(false);
      }, 1500);
    }
  };

  const handleExport = async () => {
    const params = new URLSearchParams();

    if (dateRange.length === 2) {
      params.append(
        "start",
        moment(dateRange[0]).format("YYYY-MM-DD HH:mm:ss"),
      );
      params.append("end", moment(dateRange[1]).format("YYYY-MM-DD HH:mm:ss"));
    } else {
      // Si pas de date sélectionnée, 3 derniers mois par défaut
      params.append("end", moment().format("YYYY-MM-DD HH:mm:ss"));
      params.append(
        "start",
        moment().subtract(3, "months").format("YYYY-MM-DD HH:mm:ss"),
      );
    }
    const res = await export_commandes(params.toString());
  };

  const onAddBc = async () => {
    setshowModalAdd(true);
  };

  const [lignes, setLignes] = useState([
    { nom: "", reference: "", qte: 1, prix_unitaire: 0 },
  ]);

  const addLigne = () => {
    setLignes([
      ...lignes,
      { nom: "", reference: "", qte: 1, prix_unitaire: 0 },
    ]);
  };

  const removeLigne = (index) => {
    const newLignes = [...lignes];
    newLignes.splice(index, 1);
    setLignes(newLignes);
  };

  const updateLigne = (index, field, value) => {
    const newLignes = [...lignes];
    newLignes[index][field] = value;
    setLignes(newLignes);
  };

  const updateCamionField = (index, field, value) => {
    setSelectedCamion((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item)),
    );
  };

  const onSubmit = async () => {
    setLoading(true);
    console.log(selectedCamion);
    const payload = {
      lignes,
      factures_id: selectedFactures,
      camions: selectedCamion,
    };
    const res = await create_additionnal_commande(payload);
    if (res.status === "success") {
      setnotif({
        ...notif,
        message: "Bon de commande créé avec succès",
        info: "success",
      });
      setshowToast(true);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } else {
      message.warning("Erreur lors de la création du bon de commande !!!");
      setnotif({
        ...notif,
        message: "Erreur lors de la création du bon de commande !!!",
        info: "error",
      });
      setshowToast(true);
      setTimeout(() => {
        setshowToast(false);
      }, 1500);
    }
  };

  const onFactureChanged = (value) => {
    console.log(value);
    console.log(listeFactures);
    const coef_vide = value
      ? listeFactures.find((f) => f.id === value)?.coefficient_vide
      : 0;
    const coef_charge = value
      ? listeFactures.find((f) => f.id === value)?.coefficient_charge
      : 0;
    console.log(coef_vide, coef_charge);
    updateCamionField(0, "coefficient_vide", coef_vide);
    updateCamionField(0, "coefficient_charge", coef_charge);
    setselectedFactures(value);
  };

  return (
    <div className="p-0">
      <div className="flex justify-between items-center mb-4">
        <Space style={{ width: "85%" }}>
          <Input
            placeholder="🔍 Rechercher..."
            value={searchText}
            onChange={handleSearch}
            prefix={<SearchOutlined />}
            style={{ width: 250 }}
          />
          <RangePicker showTime onChange={handleDateChange} size="small" />
          <Button
            icon={<ReloadOutlined />}
            onClick={() => fetchCommandes(dateRange)}
            loading={loading}
            style={{
              backgroundColor: "#0d6efd",
              borderColor: "#0d6efd",
              color: "#fff",
            }}
          >
            Recharger
          </Button>
          {hasPermission(
            getPermissionsFromToken(),
            "COMMANDE_ADD_ADDITIONNAL",
          ) && (
              <Button
                icon={<PlusOutlined />}
                onClick={onAddBc}
                loading={loading}
                style={{
                  backgroundColor: "#109b3f",
                  borderColor: "#109b3f",
                  color: "#fff",
                }}
              >
                Ajouter
              </Button>
            )}
        </Space>
        {hasPermission(getPermissionsFromToken(), "COMMANDE_EXPORT") && (
          <Button
            icon={<PlusOutlined />}
            style={{
              backgroundColor: "#198754",
              borderColor: "#198754",
              color: "#fff",
            }}
            onClick={handleExport}
          >
            Exporter
          </Button>
        )}
      </div>
      <Spin spinning={loading}>
        <div
          style={{
            height: "70vh",
            overflowY: "auto",
          }}
        >
          <Table
            rowKey="id"
            columns={columns_commandes}
            dataSource={filteredCommandes}
            loading={loading}
            pagination={{
              pageSize: 10,
              position: ["bottomCenter"],
              className: "custom-pagination",
              style: {
                display: "flex",
                justifyContent: "center",
                marginTop: 12,
              },
              itemRender: (page, type, originalElement) => {
                if (type === "page") {
                  return (
                    <div
                      style={{
                        borderRadius: "50%",
                        minWidth: 32,
                        height: 32,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "1px solid #d9d9d9",
                      }}
                    >
                      {page}
                    </div>
                  );
                }
                return originalElement;
              },
            }}
            onChange={handleTableChange}
            rowSelection={rowSelection} // ✅ ajouté ici
          />
        </div>
      </Spin>
      {showToast && (
        <Notification message={notif.message} status={notif.info} />
      )}

      <Modal
        title={
          <span style={{ fontSize: 18, fontWeight: 600 }}>
            Détails de la commande {selectedCommandes.ref_commande || ""}
            {isCommandeLocked && (
              <Tag color="green" style={{ marginLeft: 10 }}>
                Validé — lecture seule
              </Tag>
            )}
          </span>
        }
        open={showmodaldetail}
        onCancel={handleCloseShowModal}
        width="55%"
        style={{ top: 10 }}
        bodyStyle={{ background: "#fafafa", paddingBottom: 10 }}
        footer={[
          <Button key="cancel" onClick={handleCloseShowModal}>
            Annuler
          </Button>,
          currentStep === 1 && (
            <Button key="next" type="primary" onClick={() => setCurrentStep(2)}>
              Suivant
            </Button>
          ),
          currentStep === 2 && (
            <>
              <Button key="prev" onClick={() => setCurrentStep(1)}>
                Précédent
              </Button>
              {!isCommandeLocked && (
                <Button key="confirm" type="primary" onClick={() => handleUpdate()}>
                  Confirmer
                </Button>
              )}
            </>
          ),
        ]}
      >
        {currentStep === 1 && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "12px 32px",
              marginBottom: 25,
              background: "#fff",
              padding: "16px 20px",
              borderRadius: 12,
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
            }}
          >
            {/* Agence */}
            <div>
              <label style={{ fontWeight: 500 }}>Agence</label>
              <Input
                disabled={isCommandeLocked}
                value={selectedCommandes.agence || ""}
                onChange={(e) => updateField("agence", e.target.value)}
              />
            </div>

            {/* Compagnie */}
            <div>
              <label style={{ fontWeight: 500 }}>Compagnie</label>
              <Input
                disabled={isCommandeLocked}
                value={selectedCommandes.compagnie || ""}
                onChange={(e) => updateField("compagnie", e.target.value)}
              />
            </div>

            {/* Camion */}
            <div>
              <label style={{ fontWeight: 500 }}>Camion</label>
              <Input
                disabled={isCommandeLocked}
                value={selectedCommandes.ref_camion || ""}
                onChange={(e) => updateField("ref_camion", e.target.value)}
              />
            </div>

            {/* Remorque */}
            <div>
              <label style={{ fontWeight: 500 }}>Remorque</label>
              <Input
                disabled={isCommandeLocked}
                value={selectedCommandes.imm_remorque || ""}
                onChange={(e) => updateField("imm_remorque", e.target.value)}
              />
            </div>

            {/* Chauffeur */}
            <div>
              <label style={{ fontWeight: 500 }}>Chauffeur</label>
              <Select
                disabled={isCommandeLocked}
                value={selectedCommandes.chauffeur_commande}
                onChange={(value) => updateField("chauffeur_commande", value)}
                style={{ width: "100%" }}
              >
                {listeChauffeur?.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.prenom}
                  </Select.Option>
                ))}
              </Select>
            </div>

            {/* Observation */}
            <div style={{ gridColumn: "1 / 3" }}>
              <label style={{ fontWeight: 500 }}>Observation</label>
              <Input.TextArea
                disabled={isCommandeLocked}
                value={selectedCommandes.observation || ""}
                onChange={(e) => updateField("observation", e.target.value)}
                rows={2}
              />
            </div>

            {/* Date départ */}
            <div>
              <label style={{ fontWeight: 500 }}>Date de départ</label>
              <Input
                disabled={isCommandeLocked}
                type="date"
                value={selectedCommandes.date_depart?.substring(0, 10)}
                onChange={(e) => updateField("date_depart", e.target.value)}
              />
            </div>

            {/* Date arrivée */}
            <div>
              <label style={{ fontWeight: 500 }}>Date d'arrivée</label>
              <Input
                disabled={isCommandeLocked}
                type="date"
                value={selectedCommandes.date_arrive?.substring(0, 10)}
                onChange={(e) => updateField("date_arrive", e.target.value)}
              />
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div
            style={{
              background: "#fff",
              padding: "6px 0",
              borderRadius: 12,
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
            }}
          >
            <div
              style={{
                fontWeight: 600,
                marginBottom: 10,
                paddingLeft: 16,
                fontSize: 16,
              }}
            >
              Charges du transport
            </div>

            <Table
              dataSource={dataSource}
              columns={columns}
              pagination={{
                pageSize: 10,
                position: ["bottomCenter"],
                className: "custom-pagination",
                style: {
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 12,
                },
                itemRender: (page, type, originalElement) => {
                  if (type === "page") {
                    return (
                      <div
                        style={{
                          borderRadius: "50%",
                          minWidth: 32,
                          height: 32,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: "1px solid #d9d9d9",
                        }}
                      >
                        {page}
                      </div>
                    );
                  }
                  return originalElement;
                },
              }}
              size="small"
              bordered={false}
              rowClassName={(_, index) =>
                index % 2 === 0 ? "table-row-light" : "table-row-dark"
              }
              style={{
                borderRadius: 12,
                overflow: "hidden",
              }}
              footer={() => (
                <div style={{ textAlign: "right", marginTop: 12 }}>
                  <strong>Total: {totalGeneral.toLocaleString()} Ar</strong>
                </div>
              )}
            />
          </div>
        )}
      </Modal>

      <Modal
        title={`Valider la commande ${selectedCommandes?.ref_commande || ""}`}
        open={validationModalVisible}
        onCancel={closeValidationModal}
        footer={[
          <Button key="cancel" onClick={closeValidationModal}>
            Annuler
          </Button>,
          <Button key="confirm" type="primary" onClick={handleValidateCommande}>
            Confirmer
          </Button>,
        ]}
      >
        <Row>
          <Col span={6}>
            <p>Choisir le statut :</p>
          </Col>
          <Col span={18} style={{ padding: 10 }}>
            <Select
              size="large"
              value={selectedCommandes.statut_commande}
              onChange={(val) => {
                updateField("statut_commande", val);
              }}
              style={{ width: "100%", textAlign: "center" }}
            >
              <Option value="valide_direction">Validé par Masoandro</Option>
              <Option value="invalide_direction">Invalidé par Masoandro</Option>
              <Option value="attente_masoandro">
                En attente de validation Masoandro
              </Option>
            </Select>
          </Col>
        </Row>
      </Modal>

      <Modal
        title="Création de la commande"
        open={showModalAdd}
        onCancel={() => setshowModalAdd(false)}
        width={1000} // un peu plus large pour tout tenir
        footer={[
          <Button key="cancel" onClick={() => setshowModalAdd(false)}>
            Annuler
          </Button>,
          <Button key="confirm" type="primary" onClick={onSubmit}>
            Créer
          </Button>,
        ]}
      >
        {/* FACTURES */}
        <div style={{ marginBottom: 20 }}>
          <Text strong>Factures liées</Text>
          <Select
            showSearch
            // mode="multiple"
            style={{ width: "100%", marginTop: 5 }}
            placeholder="Sélectionner les factures"
            value={selectedFactures}
            onChange={(value) => {
              onFactureChanged(value);
            }}
          >
            {listeFactures &&
              listeFactures?.map((f) => (
                <Option key={f.id} value={f.id}>
                  {f.ref_facture || `Facture #${f.id}`}
                </Option>
              ))}
          </Select>
        </div>

        <div>
          {selectedCamion &&
            selectedCamion.map((item, index) => (
              <div
                key={index}
                style={{
                  border: "1px solid #e5e5e5",
                  borderRadius: 8,
                  padding: 15,
                  marginBottom: 20,
                  background: "#fafafa",
                }}
              >
                {/* Ligne Camion + Coeffs */}
                <Row gutter={12} align="middle">
                  <Col span={6}>
                    <Select
                      size="large"
                      placeholder="Choisir camion"
                      style={{ ...commonInputStyle, marginTop: 25 }}
                      value={item.camion_id}
                      onChange={(val) => {
                        const camion = listeCamions.find((c) => c.id === val);
                        updateCamionField(index, "camion_id", val);
                        if (camion?.chauffeur_id) {
                          updateCamionField(
                            index,
                            "chauffeur_id",
                            camion.chauffeur_id,
                          );
                        }
                      }}
                    >
                      {listeCamions?.map((c) => (
                        <Option key={c.id} value={c.id}>
                          {c.imm}
                        </Option>
                      ))}
                    </Select>
                  </Col>

                  <Col span={6}>
                    <Select
                      size="large"
                      placeholder="Choisir chauffeur"
                      style={{
                        ...commonInputStyle,
                        marginTop: 25,
                        textAlign: "center",
                      }}
                      value={item.chauffeur_id}
                      onChange={(val) =>
                        updateCamionField(index, "chauffeur_id", val)
                      }
                    >
                      {listeChauffeur?.map((c) => (
                        <Option key={c.id} value={c.id}>
                          {c.prenom}
                        </Option>
                      ))}
                    </Select>
                  </Col>

                  <Col span={4} style={{ textAlign: "center" }}>
                    <span style={{ fontWeight: 500 }}>Coeff chargé</span>
                    <Input
                      value={item.coefficient_charge ?? ""}
                      onChange={(e) =>
                        updateCamionField(
                          index,
                          "coefficient_charge",
                          e.target.value,
                        )
                      }
                      style={{
                        ...commonInputStyle,
                        paddingTop: 10,
                        background: "#fff",
                      }}
                      placeholder="ex: 0.3"
                    />
                  </Col>

                  <Col span={4} style={{ textAlign: "center" }}>
                    <span style={{ fontWeight: 500 }}>Coeff vide</span>
                    <Input
                      value={item.coefficient_vide ?? ""}
                      onChange={(e) =>
                        updateCamionField(
                          index,
                          "coefficient_vide",
                          e.target.value,
                        )
                      }
                      style={{
                        ...commonInputStyle,
                        paddingTop: 10,
                        background: "#fff",
                      }}
                      placeholder="ex: 0.3"
                    />
                  </Col>
                </Row>

                {/* Ligne compagnie + agence */}
                <Row gutter={12} style={{ marginTop: 15 }} align="middle">
                  <Col span={12}>
                    <label style={{ fontWeight: 500 }}>Compagnie</label>
                    <Input
                      placeholder="Nom de la compagnie"
                      value={item.compagnie}
                      onChange={(e) =>
                        updateCamionField(index, "compagnie", e.target.value)
                      }
                      style={{ marginTop: 5 }}
                    />
                  </Col>

                  <Col span={12}>
                    <label style={{ fontWeight: 500 }}>Agence</label>
                    <Input
                      placeholder="Agence"
                      value={item.agence}
                      onChange={(e) =>
                        updateCamionField(index, "agence", e.target.value)
                      }
                      style={{ marginTop: 5 }}
                    />
                  </Col>
                </Row>

                {/* Observation */}
                <Row style={{ marginTop: 15 }}>
                  <Col span={24}>
                    <TextArea
                      rows={3}
                      placeholder="Observation"
                      value={item.observation}
                      onChange={(e) =>
                        updateCamionField(index, "observation", e.target.value)
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}
        </div>
        <Divider />

        {/* HEADER */}
        <Row gutter={8} style={{ marginBottom: 8 }}>
          <Col span={6}>
            <Text strong>Désignation</Text>
          </Col>
          <Col span={4}>
            <Text strong>Réf</Text>
          </Col>
          <Col span={3}>
            <Text strong>Qté</Text>
          </Col>
          <Col span={5}>
            <Text strong>Prix Unitaire</Text>
          </Col>
          <Col span={4}>
            <Text strong>Total</Text>
          </Col>
          <Col span={2}></Col>
        </Row>

        {/* LIGNES */}
        {lignes.map((ligne, index) => {
          const totalLigne = (ligne.qte || 0) * (ligne.prix_unitaire || 0);

          return (
            <Row
              key={index}
              gutter={8}
              align="middle"
              style={{ marginBottom: 8 }}
            >
              {/* NOM */}
              <Col span={6}>
                <Input
                  placeholder="Désignation"
                  value={ligne.nom}
                  onChange={(e) => updateLigne(index, "nom", e.target.value)}
                />
              </Col>

              {/* REF */}
              <Col span={4}>
                <Input
                  placeholder="Réf"
                  value={ligne.ref}
                  onChange={(e) => updateLigne(index, "ref", e.target.value)}
                />
              </Col>

              {/* QTE */}
              <Col span={3}>
                <InputNumber
                  min={1}
                  style={{ width: "100%" }}
                  value={ligne.qte}
                  onChange={(value) => updateLigne(index, "qte", value)}
                />
              </Col>

              {/* PRIX */}
              <Col span={5}>
                <InputNumber
                  min={0}
                  style={{ width: "100%" }}
                  value={ligne.prix_unitaire}
                  onChange={(value) =>
                    updateLigne(index, "prix_unitaire", value)
                  }
                />
              </Col>

              {/* TOTAL */}
              <Col span={4} style={{ textAlign: "right" }}>
                <Text>{totalLigne.toLocaleString()} Ar</Text>
              </Col>

              {/* ACTIONS */}
              <Col span={2} style={{ display: "flex", gap: 5 }}>
                <Button icon={<PlusOutlined />} onClick={addLigne} />

                {lignes.length > 1 && (
                  <Button
                    danger
                    icon={<MinusOutlined />}
                    onClick={() => removeLigne(index)}
                  />
                )}
              </Col>
            </Row>
          );
        })}

        <Divider />

        {/* TOTAL GLOBAL */}
        <Row justify="end">
          <Col>
            <Text strong>
              Total général :{" "}
              {lignes
                .reduce((sum, l) => sum + l.qte * l.prix_unitaire, 0)
                .toLocaleString()}{" "}
              Ar
            </Text>
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default Commandes;